import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Menu, X } from "lucide-react";

const SaaSHeader = () => {
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navLinks = [];

  return (
    <header className="fixed top-0 left-0 w-full z-50 bg-white/80 backdrop-blur-md border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between">
        {/* LEFT SIDE: LOGO & BRANDING */}
        <div className="flex items-center gap-3">
          <Link to="/" className="flex items-center gap-3 group">
            <img 
              src="/logo192.png" 
              alt="The Skill Genie" 
              className="w-12 h-12 rounded-lg shadow-sm group-hover:scale-105 transition-transform" 
            />
            <div className="flex flex-col justify-center">
              <span className="text-lg font-black text-gray-900 leading-none tracking-tight">THE SKILL GENIE</span>
              <span className="text-[12px] font-bold text-purple-600 mt-0.5 uppercase tracking-wider">Bridging the Gap from Learning to Industry Readiness.</span>
            </div>
          </Link>
        </div>

        {/* CENTER NAVIGATION: DESKTOP */}
        {navLinks.length > 0 && (
          <nav className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              link.isExternal ? (
                <a 
                  key={link.label} 
                  href={link.path} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-sm font-semibold text-gray-600 hover:text-purple-600 transition-colors"
                >
                  {link.label}
                </a>
              ) : (
                <Link 
                  key={link.label} 
                  to={link.path} 
                  className="text-sm font-semibold text-gray-600 hover:text-purple-600 transition-colors"
                >
                  {link.label}
                </Link>
              )
            ))}
          </nav>
        )}

        {/* RIGHT SIDE: AUTH CTAs */}
        <div className="flex items-center gap-6">
          <a 
            href="https://www.theskillgenie.com/contact" 
            target="_blank" 
            rel="noopener noreferrer"
            className="hidden lg:block text-sm font-semibold text-gray-600 hover:text-purple-600 transition-colors"
          >
            Contact Us
          </a>
          <Link 
            to="/login" 
            className="hidden lg:block text-sm font-bold text-gray-600 hover:text-purple-600 transition-colors"
          >
            Login
          </Link>
          <button 
            onClick={() => navigate("/usertype")}
            className="hidden lg:block px-6 py-2.5 bg-purple-600 text-white text-sm font-bold rounded-full hover:bg-purple-700 transition-all shadow-md shadow-purple-200"
          >
            Get Started
          </button>

          {/* MOBILE MENU TOGGLE */}
          <button 
            className="lg:hidden p-2 text-gray-600"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* MOBILE MENU */}
      {mobileMenuOpen && (
        <div className="lg:hidden absolute top-20 left-0 w-full bg-white border-b border-gray-100 shadow-xl p-6 animate-slideIn">
          <nav className="flex flex-col gap-4">
            {navLinks.length > 0 && navLinks.map((link) => (
              link.isExternal ? (
                <a 
                  key={link.label} 
                  href={link.path} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  onClick={() => setMobileMenuOpen(false)}
                  className="text-base font-semibold text-gray-700 hover:text-purple-600"
                >
                  {link.label}
                </a>
              ) : (
                <Link 
                  key={link.label} 
                  to={link.path} 
                  onClick={() => setMobileMenuOpen(false)}
                  className="text-base font-semibold text-gray-700 hover:text-purple-600"
                >
                  {link.label}
                </Link>
              )
            ))}
            {navLinks.length > 0 && <hr className="my-2 border-gray-100" />}
            <a 
              href="https://www.theskillgenie.com/contact" 
              target="_blank" 
              rel="noopener noreferrer"
              onClick={() => setMobileMenuOpen(false)}
              className="text-base font-semibold text-gray-700 hover:text-purple-600"
            >
              Contact Us
            </a>
            <Link 
              to="/login" 
              onClick={() => setMobileMenuOpen(false)}
              className="text-base font-semibold text-gray-700"
            >
              Login
            </Link>
            <button 
              onClick={() => {
                navigate("/usertype");
                setMobileMenuOpen(false);
              }}
              className="w-full py-3 bg-purple-600 text-white text-base font-bold rounded-xl"
            >
              Get Started
            </button>
          </nav>
        </div>
      )}
    </header>
  );
};

export default SaaSHeader;
